import { compose } from "redux";
import { List } from "immutable";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Group from "@material-ui/icons/Group";
import { Field } from "redux-form/immutable";
import { withStyles } from "@material-ui/core/styles";
import { formValueSelector, initialize } from "redux-form/immutable";

import {
  GROUP_TYPES,
  CREATE_VIEW_GROUPS_FORM,
  CREATE_VIEW_GROUPS_TABS,
  CREATE_VIEW_GROUPS_MODAL_ID,
} from "features/planner/planner.constants";

import {
  createViewGroupsonEnter,
  createViewGroupsOnSubmit,
} from "features/planner/planner.actions";

import MuiOilrigIcon from "app/components/MuiOilrigIcon";
import SimpleFormModal from "app/components/SimpleFormModal";
import ModalTabField from "app/components/form/ModalTabField";
import { GroupMapper } from "features/planner/planner.mappers";
import ModalTabsField from "app/components/form/ModalTabsField";
import { EMPTY_SET, EMPTY_MAP, EMPTY_LIST } from "app/app.constants";
import { validateCreateViewGroupsForm } from "utils/validation.util";
import CreateViewGroupsForm from "features/planner/components/View/CreateViewGroups/CreateViewGroupsForm";

const CreateViewGroupsTabs = ({
  viewId,
  classes,
  locationGroups,
  planningGroups,
  dispatchInitialize,
}) => (
  <Field
    component={ModalTabsField}
    name={CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB}
    classes={{
      root: classes.tabsRoot,
    }}
  >
    {[
      {
        Icon: MuiOilrigIcon,
        tab: CREATE_VIEW_GROUPS_TABS.LOCATION_GROUP,
        title: `Location (${locationGroups.size})`,
      },
      {
        Icon: Group,
        tab: CREATE_VIEW_GROUPS_TABS.PLANNING_GROUP,
        title: `Planning Group (${planningGroups.size})`,
      },
    ].map(({ Icon, title, tab }) => (
      <Field
        key={tab}
        Icon={Icon}
        index={tab}
        value={tab}
        title={title}
        component={ModalTabField}
        name={CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB}
        onChange={nextTab =>
          dispatchInitialize(CREATE_VIEW_GROUPS_FORM.ID, {
            [CREATE_VIEW_GROUPS_FORM.VIEW_ID]: viewId,
            [CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB]: nextTab,
            [CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS]: EMPTY_SET,
          })
        }
      ></Field>
    ))}
  </Field>
);

class CreateViewGroupsModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      groupsByGroupType: EMPTY_MAP,
    };
  }

  onEnterCreateViewGroupsModal = () => {
    const { viewId, dispatchOnEnter } = this.props;

    dispatchOnEnter(viewId).then(groups => {
      this.setState({
        groupsByGroupType: List(groups)
          .map(GroupMapper.from)
          .groupBy(group => group.get("type")),
      });
    });
  };

  render() {
    const {
      viewId,
      classes,
      selectedItems,
      dispatchInitialize,
      dispatchaddToViewOnSubmit,
    } = this.props;

    const locationGroups = this.state.groupsByGroupType.get(
      GROUP_TYPES.LOCATION_GROUP,
      EMPTY_LIST,
    );

    const planningGroups = this.state.groupsByGroupType.get(
      GROUP_TYPES.PLANNING_GROUP,
      EMPTY_LIST,
    );

    return (
      <SimpleFormModal
        title="Add group"
        component={CreateViewGroupsForm}
        modalId={CREATE_VIEW_GROUPS_MODAL_ID}
        onSubmit={dispatchaddToViewOnSubmit}
        submitText={`Add (${selectedItems.size})`}
        onEnter={this.onEnterCreateViewGroupsModal}
        form={{
          destroyOnUnmount: true,
          form: CREATE_VIEW_GROUPS_FORM.ID,
          validate: validateCreateViewGroupsForm,
          initialValues: {
            [CREATE_VIEW_GROUPS_FORM.VIEW_ID]: viewId,
            [CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS]: EMPTY_SET,
            [CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB]:
              CREATE_VIEW_GROUPS_TABS.LOCATION_GROUP,
          },
        }}
        DialogProps={{
          maxWidth: "md",
        }}
        DialogContentProps={{
          classes: {
            root: classes.dialogContentRoot,
          },
        }}
        FormProps={{
          locationGroups,
          planningGroups,
        }}
        Tabs={CreateViewGroupsTabs}
        TabsProps={{
          viewId,
          classes,
          locationGroups,
          planningGroups,
          dispatchInitialize,
        }}
      />
    );
  }
}

const styles = theme => ({
  dialogContentRoot: {
    paddingTop: 0,
  },
  tabsRoot: {
    marginBottom: theme.spacing(1.5),
  },
});

CreateViewGroupsModal.defaultProps = {
  selectedItems: EMPTY_SET,
};

const addToViewFormSelector = formValueSelector(CREATE_VIEW_GROUPS_FORM.ID);

export default compose(
  connect(
    state => {
      const activeTab = addToViewFormSelector(
        state,
        CREATE_VIEW_GROUPS_FORM.ACTIVE_TAB,
      );

      return {
        activeTab,
        selectedItems: addToViewFormSelector(
          state,
          CREATE_VIEW_GROUPS_FORM.SELECTED_ITEMS,
        ),
      };
    },
    {
      dispatchInitialize: initialize,
      dispatchOnEnter: createViewGroupsonEnter,
      dispatchaddToViewOnSubmit: createViewGroupsOnSubmit,
    },
  ),
  withStyles(styles),
)(CreateViewGroupsModal);
